import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLinkIcon } from '../../Icons/Icons';
import './CompactPreview.css';

interface CompactPreviewProps {
  url: string;
  title: string;
  comment?: string;
  className?: string;
}

export const CompactPreview: React.FC<CompactPreviewProps> = ({
  url,
  title,
  comment,
  className = ''
}) => {
  const { t } = useTranslation();

  return (
    <div className={`compact-preview ${className}`}>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="compact-preview__external-link"
        title={t('preview.openInNewTab')}
      >
        <ExternalLinkIcon />
      </a>
      <div className="compact-preview__content">
        <iframe
          src={url}
          title={title}
          className="compact-preview__iframe"
          sandbox="allow-scripts allow-same-origin allow-forms"
        />
      </div>
      <div className="compact-preview__comment">
        <label className="compact-preview__comment-label">
          {t('productRegistration.form.detailLabel')}
        </label>
        <div className="compact-preview__comment-text">
          {comment || t('productRegistration.noDetailProvided', { defaultValue: '詳細説明がありません' })}
        </div>
      </div>
    </div>
  );
};